import { IButtonStyles } from 'office-ui-fabric-react';
import { cssVariableNames } from '../../../domain/theming/themes';

export const styles: IButtonStyles = {
    root: { color: cssVariableNames.neutralPrimary },
    rootHovered: { backgroundColor: cssVariableNames.white },
    icon: { color: cssVariableNames.neutralPrimary },
};
